import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Chip, dueCol, emo, FS, left, useCount } from "@/components/ch/ui";
import { rowCol, stageIdx } from "@/components/compliances/shared";

const segP = (r) => (r.status === "compliant" ? 100 : r.current ? Math.max(8, ((stageIdx(r) + 1) / 7) * 100) : 4);

function Health({ h }) {
  const personal = h.scope === "personal";
  const target = personal ? h.open_tasks : h.pct;
  const shown = useCount(target);
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/compliances").then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, [h]);
  const due = new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10);
  const kp = [["Need you", h.need_you, "#attention", "health-need"], ["Due in 30 days", h.due_30, `/tasks?window=upcoming&date_to=${due}`, "health-due30"], ["Overdue", h.overdue, "/tasks?overdue=true", "health-overdue"]];
  return (
    <section className="box mt" data-testid="health-card">
      <div className="big">{target === null ? <b style={{ fontSize: 40 }} data-testid="health-pct">Not assessed yet</b>
        : <><b data-testid={personal ? "health-open-tasks" : "health-pct"}>{shown}</b>{!personal && <sup>%</sup>}</>}<small>{personal ? "Your open tasks" : "Compliance health"}</small></div>
      {rows?.length > 0 && <div className="sgs" data-testid="health-segments">{rows.slice(0, 12).map((r) => <div key={r.id} title={r.name} data-testid={`health-seg-${r.id}`}><i style={{ "--c": rowCol(r), "--p": `${segP(r)}%` }} /><small>{r.authority?.short_name || r.name}</small></div>)}</div>}
      <div className="kp">{kp.map(([l, v, to, id]) => {
        const body = <><b data-testid={id}>{v}</b><small>{l}</small></>;
        return <div key={id}>{to.startsWith("#") ? <a href={to} data-testid={`${id}-link`}>{body}</a> : <Link to={to} data-testid={`${id}-link`}>{body}</Link>}</div>;
      })}</div>
      <small data-testid="health-rule">{personal ? "Showing only the tasks you are responsible for. The company-wide score is shown to users who can see all obligations." : `${h.rule} (${h.applicable_tasks} task${h.applicable_tasks === 1 ? "" : "s"}).`}</small>
    </section>
  );
}

export function ClientHub({ d, onOpen }) {
  const items = d.attention || [];
  const seen = new Set();
  const up = (d.upcoming || []).filter((t) => { const k = `${t.title}|${t.due_date}`; if (seen.has(k)) return false; seen.add(k); return true; }).slice(0, 6);
  const total = d.health?.need_you || 0;
  return (
    <div className="fade" data-testid="client-hub">
      {d.health && <Health h={d.health} />}
      <div className="cols">
        <section className="box" id="attention" data-testid="attention-list"><h3>Needs your attention</h3>
          {!items.length ? <p className="mu" data-testid="attention-empty">Nothing waiting on you.</p> : items.map((t) => (
            <div key={t.id} className="ar" data-testid={`attention-${t.id}`}><span className="ic">{emo(t.category)}</span>
              <div className="gr" style={{ cursor: "pointer" }} onClick={() => onOpen(t.id)}><b>{t.title}</b><small>{left(t.due_date)} · {t.next_action}{t.assignee_name ? ` · ${t.assignee_name}` : ""}</small></div>
              <button className="b sm" onClick={() => onOpen(t.id)} data-testid={`attention-action-${t.id}`}>{t.action}</button></div>))}
          {total > items.length && <Link to="/tasks" className="lk" data-testid="attention-view-all">Showing {items.length} of {total} · view all in Compliances</Link>}
        </section>
        <section className="box" data-testid="coming-up"><h3>{d.health?.scope === "personal" ? "Coming up · your deadlines" : "Coming up"}</h3>
          {!up.length ? <p className="mu" data-testid="coming-up-empty">No upcoming deadlines.</p> : <div className="tv">{up.map((t) => (
            <div key={t.id} style={{ "--c": t.status === "verified" ? "var(--ok)" : dueCol(t.due_date) }} onClick={() => onOpen(t.id)} data-testid={`coming-${t.id}`}><small>{FS(t.due_date)}</small><b>{t.title}</b><Chip c={dueCol(t.due_date)}>{left(t.due_date)}</Chip></div>))}</div>}
        </section>
      </div>
    </div>
  );
}

